module.exports = __webpack_public_path__ + "static/media/mail_email.8c5f1608.svg";